import { keyframes } from "styled-components";

export const float = keyframes`
50% {
transform: translateY(10px);
}
`;

export const scale = keyframes`
  50% {
    transform: scale(1.15, 1.15);
    -webkit-transform: scale(1.15, 1.15);
  }
`;



// WEBPACK FOOTER //
// ./src/utils/CommonAnimations.js